// extracted by mini-css-extract-plugin
export default {"mainBox":"tools_mainBox__yH64d","container":"tools_container__zTso0","sub_title":"tools_sub_title__p7dlj","services_list":"tools_services_list__nbEMW","tools":"tools_tools__iuBV5"};